import { Component, OnInit } from '@angular/core';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { IosAndAndroidNatvieFunctionsService } from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';
import { IsWrappingService } from 'dm-src/services/is-wrapping/is-wrapping.service';
import { take } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
    isApplication: boolean;
    osType: string;
    appVersion: string = 'web';

    constructor(
        private isWrappingService: IsWrappingService,
        private iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService
    ) {
        if (window.ReactNativeWebView) {
            this.isApplication = true;
        } else if (this.isWrappingService.isWrapping()) {
            this.isApplication = true;
        } else {
            this.isApplication = false;
        }

        this.osType = this.iosAndAndroidNatvieFunctionsService.getMobileOperatingSystem();
        this.getAppVersion();
    }

    ngOnInit(): void {}

    handleLoginClick(email: string) {
        const loggedIn = new Date();
        this.iosAndAndroidNatvieFunctionsService.oneSignalSetEmail(email);
        this.iosAndAndroidNatvieFunctionsService.oneSignalSetTag('UserType', 'Delivery');
        this.iosAndAndroidNatvieFunctionsService.oneSignalSetTag(
            'LastLogin',
            this.formatDate(loggedIn)
        );
    }

    handleFrontendVersion() {
        if (window.ReactNativeWebView) {
            this.iosAndAndroidNatvieFunctionsService.newFrontendUrlChoose();
        } else {
            this.iosAndAndroidNatvieFunctionsService.selectFrontendVersion(
                'Válasszon verziót.'
            );
        }
    }

    getAppVersion() {
        if (window.ReactNativeWebView) {
            this.iosAndAndroidNatvieFunctionsService.getAppVersion();

            this.iosAndAndroidNatvieFunctionsService
                .getCurrentPostMessage()
                .pipe(take(2))
                .subscribe((response) => {
                    if (response.functionName === 'GET_APP_VERSION') {
                        const version = 'Version: ' + response.result.split('#')[0];
                        const build = ', BuildNumber: ' + response.result.split('#')[1];
                        this.appVersion = version + build;
                    }
                });
        }
    }

    private formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
    }
}
